import React, { useRef, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import XIcon from "@mui/icons-material/X";
import ShieldIcon from "@mui/icons-material/Shield";
import SendIcon from "@mui/icons-material/Send";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import emailjs from "@emailjs/browser";

function Contact() {
  const form = useRef();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm(
        "service_xelyzp1", // Replace with your EmailJS service ID
        "template_fkc4ozs", // Replace with your EmailJS template ID
        form.current,
        "Cc0mBUsRTvhEX4mpz" // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log('SUCCESS!', result.text);
          setDialogOpen(true);
          setLoading(false);
          form.current.reset();
        },
        (error) => {
          console.log(error.text);
          alert(`Error: ${error.text || 'An unknown error occurred'}`);
          setLoading(false);
        }
      );
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <Box sx={{ py: 1 }}>
      <Box sx={{ mb: 3.5, textAlign: 'center' }}>
        <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 800, color: '#ef4444', fontFamily: "'Share Tech Mono', monospace" }}>
          [ Secure Message Transmission Port ]
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: '500px', mx: 'auto', fontSize: '0.85rem' }}>
          Establish an encrypted socket connection to send a direct alert transmission to root@tathagata.roy.
        </Typography>
      </Box>

      <Card sx={{ p: 1.5, border: '1px solid #1c2536', background: '#0d1017' }}>
        <CardContent sx={{ p: 1 }}>
          <Grid container spacing={3}>
            {/* Contact Details */}
            <Grid item xs={12} md={5} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 700, mb: 1.5, display: 'flex', alignItems: 'center', gap: 1, color: '#ef4444', fontFamily: "'Share Tech Mono', monospace" }}>
                  <ShieldIcon sx={{ fontSize: '1.25rem' }} /> SECURE_TUNNEL_PORT: 443
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3, fontSize: '0.8rem', lineHeight: 1.5 }}>
                  Messages sent via this console are parsed and formatted using standardized templates, forwarding direct payload packets to my inbox. Operational response times range between 24-48 hours.
                </Typography>
              </Box>

              <Box>
                <Typography variant="caption" sx={{ fontWeight: 700, mb: 1, display: 'block', color: '#ffffff', letterSpacing: '0.08em', fontFamily: "'Share Tech Mono', monospace" }}>
                  SOCIAL_SOCKETS:
                </Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <IconButton
                    href="https://www.linkedin.com/in/roy9495/"
                    target="_blank"
                    sx={{ 
                      bgcolor: 'rgba(0, 162, 255, 0.04)', 
                      color: '#00a2ff',
                      border: '1px solid rgba(0, 162, 255, 0.15)',
                      borderRadius: 1,
                      '&:hover': {
                        bgcolor: 'rgba(0, 162, 255, 0.12)',
                      }
                    }}
                  >
                    <LinkedInIcon sx={{ fontSize: '1.1rem' }} />
                  </IconButton>
                  <IconButton 
                    href="https://github.com/roy9495" 
                    target="_blank"
                    sx={{ 
                      bgcolor: 'rgba(255, 255, 255, 0.02)', 
                      color: '#ffffff',
                      border: '1px solid rgba(255, 255, 255, 0.06)',
                      borderRadius: 1,
                      '&:hover': {
                        bgcolor: 'rgba(255, 255, 255, 0.08)',
                      }
                    }}
                  >
                    <GitHubIcon sx={{ fontSize: '1.1rem' }} />
                  </IconButton>
                  <IconButton 
                    href="https://x.com/royzen9495" 
                    target="_blank"
                    sx={{ 
                      bgcolor: 'rgba(0, 162, 255, 0.04)', 
                      color: '#00a2ff',
                      border: '1px solid rgba(0, 162, 255, 0.15)',
                      borderRadius: 1,
                      '&:hover': {
                        bgcolor: 'rgba(0, 162, 255, 0.12)',
                      }
                    }}
                  >
                    <XIcon sx={{ fontSize: '1.1rem' }} />
                  </IconButton>
                </Box>
              </Box>
            </Grid>

            {/* Contact Form */}
            <Grid item xs={12} md={7}>
              <form ref={form} onSubmit={sendEmail}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <TextField
                    fullWidth
                    required
                    label="IDENTITY_NAME"
                    variant="outlined"
                    type="text"
                    name="user_name"
                    size="small"
                    InputLabelProps={{ style: { fontFamily: "'Share Tech Mono', monospace", fontSize: '0.8rem' } }}
                    inputProps={{ style: { fontFamily: "'Share Tech Mono', monospace", fontSize: '0.82rem' } }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.1)' },
                        '&:hover fieldset': { borderColor: '#ef4444' },
                        '&.Mui-focused fieldset': { borderColor: '#ef4444' }
                      }
                    }}
                  />
                  <TextField
                    fullWidth
                    required
                    label="IDENTITY_EMAIL"
                    variant="outlined"
                    type="email"
                    name="user_email"
                    size="small"
                    InputLabelProps={{ style: { fontFamily: "'Share Tech Mono', monospace", fontSize: '0.8rem' } }}
                    inputProps={{ style: { fontFamily: "'Share Tech Mono', monospace", fontSize: '0.82rem' } }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.1)' },
                        '&:hover fieldset': { borderColor: '#ef4444' },
                        '&.Mui-focused fieldset': { borderColor: '#ef4444' }
                      }
                    }}
                  />
                  <TextField
                    fullWidth
                    required
                    label="TRANSMISSION_PAYLOAD"
                    variant="outlined"
                    multiline
                    rows={4}
                    name="message"
                    size="small"
                    InputLabelProps={{ style: { fontFamily: "'Share Tech Mono', monospace", fontSize: '0.8rem' } }}
                    inputProps={{ style: { fontFamily: "'Share Tech Mono', monospace", fontSize: '0.82rem' } }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.1)' },
                        '&:hover fieldset': { borderColor: '#ef4444' },
                        '&.Mui-focused fieldset': { borderColor: '#ef4444' }
                      }
                    }}
                  />
                  <Button
                    variant="contained"
                    color="secondary"
                    type="submit"
                    disabled={loading}
                    endIcon={<SendIcon sx={{ fontSize: '0.8rem !important' }} />}
                    sx={{ 
                      py: 1,
                      fontWeight: 700,
                      fontSize: '0.78rem',
                      fontFamily: "'Share Tech Mono', monospace",
                      boxShadow: '0 4px 15px rgba(239, 68, 68, 0.15)',
                      '&:hover': {
                        boxShadow: '0 6px 20px rgba(239, 68, 68, 0.3)',
                      }
                    }}
                  >
                    {loading ? 'TRANSMITTING PAYLOAD...' : 'TRANSMIT MESSAGE'}
                  </Button>
                </Box>
              </form>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Dialog 
        open={dialogOpen} 
        onClose={handleClose}
        PaperProps={{
          sx: {
            background: '#0c0f16',
            border: '1px solid #ef444450',
            borderRadius: '4px',
            boxShadow: '0 0 20px rgba(239, 68, 68, 0.2)'
          }
        }}
      >
        <DialogTitle sx={{ color: '#ef4444', fontWeight: 700, fontFamily: "'Share Tech Mono', monospace", fontSize: '1rem' }}>
          <ShieldIcon sx={{ mr: 1, verticalAlign: 'middle', fontSize: '1.2rem' }} /> TRANSMISSION COMPLETE
        </DialogTitle>
        <DialogContent sx={{ color: 'text.secondary', fontFamily: "'Share Tech Mono', monospace", fontSize: '0.82rem' }}>
          Secure packet successfully routed and decoded at target root@tathagata.roy.
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleClose} variant="contained" color="secondary" size="small" sx={{ fontSize: '0.72rem' }}>
            CLOSE SOCKET
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Contact;
